"use strict";
function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/util/isObject.js